import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    AppBar,
    Box,
    IconButton,
    Menu,
    MenuItem,
    Toolbar,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { authManager } from '../models/exports'

const containerStyle = {
    margin: '10px 15px 0px',
}

export function WithAppBarLayout({ children, handleSignOut = f => f }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    async function signOut() {
        await authManager.singOut();
        handleSignOut();
    }

    return (
        <div>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={handleClick}
                            sx={{ mr: 2 }}>
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="demo-positioned-menu"
                            aria-labelledby="demo-positioned-button"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}>
                            <MenuItem onClick={signOut}>ログアウト</MenuItem>
                        </Menu>
                    </Toolbar>
                </AppBar>
            </Box>
            <div style={containerStyle}>
                {children}
            </div>
        </div>
    );
}
